import Vue from 'vue'

export const fetchAlertingContacts = ({commit, getters}) => {
    return Vue.prototype.$rest.get("/user/" + getters.getTargetContext.id + "/alerting").then(function (content) {
        commit("setAlertingContacts", content.data)
    })
};

export const deleteAlertingContact = ({getters, commit}, id) => {
    return Vue.prototype.$rest.delete("/user/" + getters.getTargetContext.id + "/alerting/" + id).then(function (content) {
        commit("removeAlertingContact", id)
    })
};

export const createAlertingContact = ({getters, commit}, contact) => {
    let {id, ...data} = contact;
    data = {...data, active: true};

    return Vue.prototype.$rest.post("/user/" + getters.getTargetContext.id + "/alerting", data).then(function (content) {
        commit("updateAlertingContact", contact)
    })
};
export const updateAlertingContact = ({getters, commit}, contact) => {
    let {id, ...data} = contact;

    return Vue.prototype.$rest.put("/user/" + getters.getTargetContext.id + "/alerting/" + id, data).then(function (content) {
        commit("updateAlertingContact", contact)
    })
};
export const toggleAlertingContactStatus = ({getters, commit}, {contact, enable}) => {
    let {id} = contact;
    let data = {active: enable};

    return Vue.prototype.$rest.patch("/user/" + getters.getTargetContext.id + "/alerting/" + id, data).then(function (content) {
        commit("updateAlertingContact", {...contact, active: enable})
    })
};

/*export const assignContact = ({getters, commit}, contact, sensor) => {
    let {id, ...data} = contact;

    return Vue.prototype.$rest.put("/user/" + getters.getTargetContext.id + "/contact/" + id, data).then(function (content) {
        commit("updateContact", contact)
    })
};*/


// WEBPACK FOOTER //
// ./src/store/actions/alerting.js